export default __webpack_public_path__ + "static/media/sitemap.ee1383b3.xml";